import styled from "styled-components";
import { Section } from "../../styles/reusables";
import { v, b } from "../../styles/variables";

export const ContactSection = styled(Section)`
	> div {
		flex-basis: 50%;
		width: 100%;
	}

	h3 {
		text-align: center;
		margin-bottom: ${v.mediumDist};
	}

	align-items: flex-start;
	justify-content: flex-start;
	gap: ${v.largeDist};

	.form-container {
		margin-bottom: ${v.largeDist};
	}

	@media ${b.medium} {
		flex-direction: column;
		column-gap: ${v.mediumDist};
	}

	@media ${b.large} {
		flex-direction: row;
		column-gap: ${v.mediumDist};
	}

	.contacts {
		ul {
			display: flex;
			justify-content: space-evenly;
			flex-wrap: wrap;

			a {
				display: inline-flex;
				align-items: center;
				gap: 1rem;
				position: relative;

				&::after {
					content: "";
					position: absolute;
					bottom: -10%;
					left: 0;
					width: 100%;
					height: 3px;
					background: ${({ theme }) => theme.primary};
					transform: scaleX(0);
					transform-origin: right;
					transition: transform 0.3s ease-in;
				}

				&:hover::after {
					transform: scaleX(1);
					transform-origin: left;
				}
			}
		}
	}
`;
